'use strict';

module.exports = '3.34.0';



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/version.js
// module id = 575
// module chunks = 142807904292071